'use strict';
module.exports = function NaiveLineBreak(text) {
	let complete = false;
	const self = this,
		breaks = /[\s?!]/gm,
		calculateNextBreak = function () {
			if (!text || complete) {
				return false;
			}
			const nextMatch = breaks.exec(text);
			if (!nextMatch) {
				complete = true;
				return {
					position: text.length,
					required: false
				};
			} else {
				return {
					position: breaks.lastIndex,
					required: nextMatch[0] === '\n'
				};
			}
		};
	self.nextBreak = function () {
		return calculateNextBreak();
	};
};
